import { ActiviteWordingComponent, AdditionalDataWordingComponent, CompetenceWordingComponent } from './Wording'

export const WordingRoutes = [
    {
        path: '/wording/activite',
        element: <ActiviteWordingComponent />,
        role: 'Pocahontas_Wording'
    },
    {
        path: '/wording/competence',
        element: <CompetenceWordingComponent />,
        role: 'Pocahontas_Wording'
    },
    {
        path: '/wording/additionaldata',
        element: <AdditionalDataWordingComponent />,
        role: 'Pocahontas_Wording'
    }
];